import React from "react";
import { Tag } from "lucide-react";
import { batasBawah, alasanKurang } from "@/lib/hargaKhusus";

const rupiah = (n) => "Rp" + Number(n || 0).toLocaleString("id-ID");
const inputCls = "w-full min-h-[40px] rounded-md border border-slate-700 bg-slate-950 px-2.5 text-sm text-slate-100 outline-none focus:border-soq-biru";
const labelCls = "block text-[11px] font-semibold text-slate-400 mb-1";

// HARGA-KHUSUS (owner 2026-10-11/12): a unit price typed by the cashier with a reason.
// The floor shown is a hint; the server refuses anything under it (only the owner may).
export function HargaKhususField({ line, barang, onChange, testid, owner = false }) {
  const batas = batasBawah(barang);
  if (!line.hk_on) {
    return (
      <button type="button" data-testid={`${testid}-buka`} onClick={() => onChange({ hk_on: true })}
        className="inline-flex items-center gap-1 rounded-md border border-slate-700 bg-slate-800/60 px-2 py-1 text-xs text-slate-300 hover:border-amber-500/40 hover:text-amber-300">
        <Tag size={12} /> Harga khusus
      </button>
    );
  }
  const kurang = alasanKurang(line.harga_khusus_alasan);
  const bawah = !owner && batas != null && line.harga_khusus !== "" && parseInt(line.harga_khusus, 10) < batas;
  return (
    <div data-testid={testid} className="col-span-full grid grid-cols-1 sm:grid-cols-3 gap-2 rounded-md border border-amber-500/40 bg-amber-50 p-2">
      <div>
        <label className={labelCls}>Harga khusus / satuan (Rp)</label>
        <input data-testid={`${testid}-harga`} type="number" min="0" value={line.harga_khusus}
          onChange={(e) => onChange({ harga_khusus: e.target.value })} className={inputCls} />
        {batas != null && <p data-testid={`${testid}-batas`} className={`mt-1 text-[11px] ${bawah ? "text-red-600 font-semibold" : "text-slate-500"}`}>
          {owner ? "Harga Member" : "Batas bawah Kasir/CS"}: {rupiah(batas)}{bawah ? " — di bawah batas, hanya Owner" : ""}</p>}
      </div>
      <div className="sm:col-span-2">
        <label className={labelCls}>Alasan harga khusus (wajib, min. 10 huruf)</label>
        <input data-testid={`${testid}-alasan`} value={line.harga_khusus_alasan} placeholder="mis. pesan 50 pcs, langganan"
          onChange={(e) => onChange({ harga_khusus_alasan: e.target.value })} className={inputCls} />
        <div className="mt-1 flex justify-between gap-2 text-[11px]">
          <span className={kurang ? "text-red-600" : "text-slate-500"}>{kurang ? "Alasan belum cukup" : "Tercatat di audit log"}</span>
          <button type="button" data-testid={`${testid}-tutup`} onClick={() => onChange({ hk_on: false, harga_khusus: "", harga_khusus_alasan: "" })}
            className="text-slate-500 underline hover:text-red-600">Batal harga khusus</button>
        </div>
      </div>
    </div>
  );
}

// reason of a line or nota discount — shown as soon as a discount is typed
export function AlasanDiskon({ nilai, value, onChange, testid, label = "Alasan diskon" }) {
  if (!((parseInt(nilai, 10) || 0) > 0)) return null;
  const kurang = alasanKurang(value);
  return (
    <div data-testid={testid} className="col-span-full">
      <label className={labelCls}>{label} (wajib, min. 10 huruf)</label>
      <input data-testid={`${testid}-input`} value={value || ""} onChange={(e) => onChange(e.target.value)}
        placeholder="mis. pembulatan, customer langganan" className={`${inputCls} ${kurang ? "border-red-400" : ""}`} />
    </div>
  );
}
